import { render, staticRenderFns } from "./BkCalendar.vue?vue&type=template&id=766a47df&scoped=true"
import script from "./BkCalendar.vue?vue&type=script&lang=js"
export * from "./BkCalendar.vue?vue&type=script&lang=js"
import style0 from "./BkCalendar.vue?vue&type=style&index=0&id=766a47df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766a47df",
  null
  
)

export default component.exports